module.exports = __webpack_public_path__ + "static/media/bloom.55f25d1b.png";